export enum ClickUpUrl {
  STANDARD_LOG_ISSUE = 'https://forms.clickup.com/f/a1cju-5587/49DZYKRXDOGVLBOQNO',
  CLEARDESK_LOG_ISSUE = 'https://forms.clickup.com/10531418/f/a1cju-25162/87KGGDM4GE8EA1G54I'
}
